//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Facet.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/ugmath.js";
import "../no/SelectObjectList.js";
let d=[[[1,"EdgeHole",0,"SelectNXObjectList",0],[0,"EdgeSelectionMethod",1,0],[0,"EditCopy",1,0],[0,"EndEdgeVertex1",1,"Point",0],[0,"EndEdgeVertex2",1,"Point",0],[1,"EndHole",0,"SelectNXObjectList",0],[1,"FacetBodies",0,"SelectNXObjectList",0],[1,"InnerHole",0,"SelectNXObjectList",0],[0,"MaxEdges",1,0],[1,"OuterHole",0,"SelectNXObjectList",0],[0,"SmoothnessOption",1,0],[0,"StartEdgeVertex1",1,"Point",0],[0,"StartEdgeVertex2",1,"Point",0],[1,"StartHole",0,"SelectNXObjectList",0],[0,"Type",1,0],[0,"TypeOfHole",1,0],[0,"Vertex1",1,"Point",0],[0,"Vertex2",1,"Point",0]],[[[],"FlipRangeStart",{},0,0],[[],"FlipRangeEnd",{},0,0],[["facetVertexData"],"SetCloseNotchVertex1",{},1,0],[["facetVertexData"],"SetCloseNotchVertex2",{},1,0],[["facetVertexData"],"SetBridgeGapStartEdgeVertex1",{},1,0],[["facetVertexData"],"SetBridgeGapStartEdgeVertex2",{},1,0],[["facetVertexData"],"SetBridgeGapEndEdgeVertex1",{},1,0],[["facetVertexData"],"SetBridgeGapEndEdgeVertex2",{},1,0],[[],"UpdateHoles",{},0,0]],[]];
SPLM.Facet.FillMeshBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Facet.FillMeshBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Facet.FillMeshBuilder.FacetVertexData = class{
    constructor(face,nxFacetIndex,pointCoord){
        this.face=face;this.nxFacetIndex=nxFacetIndex;this.pointCoord=pointCoord;}
    get Face(){return this.face}
    set Face(val){this.face = val}
    get Nxfacetindex(){return this.nxFacetIndex}
    set Nxfacetindex(val){this.nxFacetIndex = val}
    get Pointcoord(){if(this.pointCoord === undefined) this.pointCoord = new SPLM.Point3d(); return this.pointCoord}
    set Pointcoord(val){this.pointCoord = val}
};

SPLM.Facet.FillMeshBuilder.Types = Object.freeze({
    "FillHole" : "FillHole", "CloseNotch" : "CloseNotch", "FillIsland" : "FillIsland", "ConnectHoles" : "ConnectHoles", "BridgeGap" : "BridgeGap"});

SPLM.Facet.FillMeshBuilder.EdgeOptionMenu = Object.freeze({
    "All" : "All", "UserSelected" : "UserSelected", "ByNumberofEdges" : "ByNumberofEdges"});

SPLM.Facet.FillMeshBuilder.SmoothnessOptionMenu = Object.freeze({
    "Linear" : "Linear", "Refined" : "Refined", "TangentBased" : "TangentBased", "CurvatureBased" : "CurvatureBased"});

export default SPLM;